<template>
  <div class="image-list-component"
       :class="[
           `type-${showMore ? '' : imageType }`,
          ]"
  >
    <preview-image class="image-item"
                   v-for="(img,index) in imgList"
                   :src="pageType === 'diary'? img.url : img"
                   :key="index"
                   :index="index"
                   alt=""
    />
    <div class="img-modal"
         :class="[
           `type-${imageType}`,
         ]"
         @click="handleImageList"
         v-if="!showMore && list.length > 9"
    >
      <div class="num"><span>{{ list.length }}</span>张</div>
      <div class="desc">查看更多</div>
    </div>
  </div>
</template>

<script>
  import Viewer from 'viewerjs';
  import 'viewerjs/dist/viewer.css';
  import PreviewImage from '@/pages/ProjectWork/components/PreviewImage';

  export default {
    name: 'ImageList',
    components: {
      PreviewImage,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      imageType: {
        type: String,
        default: 'normal',
      },
      showMore: {
        type: Boolean,
        default: false,
      },
      projectId: {
        type: Number,
      },
      seq: {
        type: Number,
      },
      userId: {
        type: Number,
      },
      pageType: {
        type: String,
      },
    },
    computed: {
      imgList() {
        if (!this.showMore) {
          let list = [];
          list = this.list.slice(0, 9);
          return list;
        }
        return this.list;
      },
    },
    methods: {
      handleImageList() {
        if (this.pageType === 'diary') {
          this.$router.push({
            name: 'ProjectImage',
            query: {
              id: this.projectId,
              userId: this.userId,
              page: 'diary',
            },
          });
        } else if (this.pageType === 'work') {
          this.$router.push({
            name: 'ProjectImage',
            query: {
              id: this.projectId,
              userId: this.userId,
              page: 'work',
            },
          });
        }
      },
    },
    created() {
      this.$nextTick(() => {
        const imageLists = document.getElementsByClassName('image-list-component');
        for (let i = 0; i < imageLists.length; i++) {
          new Viewer(imageLists[i], {
            toolbar: false,
            navbar: false,
            title: false,
          });
        }
      });
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .image-list-component {
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    margin-left: @size-extra-small;
    &.type-normal {
      width: 510px;
    }
    &.type-large {
      width: 510px;
    }
    .image-item {
      margin: 0 @size-extra-small @size-extra-small 0;
    }
    .img-modal {
      flex-shrink: 0;
      position: absolute;
      right: 13px;
      bottom: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: @border-radius-normal;
      background: fade(#333, 50%);
      color: @color-white;
      font-size: @font-size-small;
      line-height: 1;
      box-sizing: border-box;
      &.type-normal {
        width: 158px;
        height: 158px;
      }
      &.type-large {
        width: 198px;
        height: 198px;
      }
      span {
        margin-right: @size-extra-small / 2;
        font-size: @font-size-extra-large;
        font-weight: @font-weight-bold;
        line-height: 1;
      }
      .desc {
        margin-top: 6px;
        line-height: 1;
      }
    }
  }

</style>
